import { render, staticRenderFns } from "./IconUpload.vue?vue&type=template&id=27114b80&"
import script from "./IconUpload.vue?vue&type=script&lang=js&"
export * from "./IconUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports